import * as React from "react";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import MenuList from "@mui/material/MenuList";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import editIcon from "../../../assets/images/client/edit_client.png";
import EditNoteIcon from '@mui/icons-material/EditNote';
import { useFullPageLoading } from "../../../atoms/full-page-loading/loadingContext";
import { useSnackbar } from "notistack";
import { sendForgetPassLink } from "../../../organisms/login/helper";
import { Dialog, DialogActions, DialogTitle } from "@mui/material";
import { BoxFlex } from "../../../atoms/boxSpaceBtw";
import CustomBtnFilled from "../../../atoms/form-molecules/CustomBtnFilled";

type Props = {
  contact_email: string;
  openEditContact: () => void;
}

export default function ContactCardMenu({ contact_email, openEditContact }: Props) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const { setLoading: setSubmitted } = useFullPageLoading();
  const { enqueueSnackbar } = useSnackbar();

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const onItemClick = (funx: () => void) => {
    funx();
    setAnchorEl(null);
  };

  const [openDialog, setOpenDialog] = React.useState(false);
  const handleResetPassword = () => {
    setOpenDialog(true);
  }
  const resetPassword = async () => {
    setOpenDialog(false);
    setSubmitted(true);
    await
      sendForgetPassLink(
        contact_email,
        () => { },
        setSubmitted,
        enqueueSnackbar,
        true
      )
  }
  return (
    <div
      style={{
        marginLeft: "0.25rem",
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "flex-end",
      }}
    >
      <IconButton
        aria-label="more"
        id="long-button"
        aria-controls={open ? "long-menu" : undefined}
        aria-expanded={open ? "true" : undefined}
        aria-haspopup="true"
        onClick={handleClick}
        sx={{ width: "32px", height: "32px", fontFamily: "inherit" }}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="long-menu"
        MenuListProps={{
          "aria-labelledby": "long-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        sx={{ fontSize: "12px", fontFamily: "inherit" }}
      >
        <MenuList dense>
          <CustomMenuItem
            label={"Edit Client Contact"}
            MaterialIcon={EditNoteIcon}
            onClick={() => {
              openEditContact();
            }}
          />
          <CustomMenuItem
            label={"Reset Password"}
            icon={editIcon}
            onClick={handleResetPassword}
          />
        </MenuList>
      </Menu>
      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}>
        <DialogTitle>Are you Sure you want to Reset Password ?</DialogTitle>
        <DialogActions>
          <BoxFlex sx={{ gap: "0.5rem" }}>
            <CustomBtnFilled
              variant="outlined"
              onClick={() => setOpenDialog(false)}
              label="Cancel"
            />
            <CustomBtnFilled
              variant="contained"
              onClick={resetPassword}
              label="Yes"
            />
          </BoxFlex>
        </DialogActions>
      </Dialog>
    </div>
  );
}

const CustomMenuItem = ({
  label,
  icon,
  MaterialIcon,
  onClick,
}: {
  label: String;
  onClick: () => void;
  icon?: string;
  MaterialIcon?: any;
}) => {
  return (
    <MenuItem onClick={onClick}>
      <ListItemIcon>
        {MaterialIcon ?
          <MaterialIcon /> :
          icon ? <img src={icon} width="16px" height="16px" /> : ""
        }
      </ListItemIcon>
      <ListItemText
        sx={{ fontSize: "12px", fontFamily: "inherit" }}
        disableTypography
      >
        {label}
      </ListItemText>
    </MenuItem>
  );
};
